import React from 'react';
import { observer } from 'mobx-react-lite';
import { IMInputText, IMSelect } from '@insurancemenu/imenu-components-lib';
import SectionTitle from 'components/common/general/SectionTitle';
import DomainProductLines from 'components/common/initiate-proposal/DomainProductLines';
import {
  FollowingSectionTitleStyled,
  IMZipCodeFieldStyled,
  IMZipCountyFieldStyled,
  IMZipStateFieldStyled,
  TabIMFormStyled,
} from 'components/common/initiate-proposal/styles';
import BasicInfoStepController from 'store/pages/initiate-quote/default/step-controllers/basicInfoStepController';
import { DEFAULT_INITIATE_PROPOSAL_FORM_ID } from './constants';

interface Props {
  basicInfoStepController: BasicInfoStepController;
}

const DefaultInitiateProposalForm: React.FC<Props> = observer(({ basicInfoStepController }) => {
  const { form, effectiveDatesOptions, domainProductLineItems, isDomainProductLinesLoading } = basicInfoStepController;

  return (
    <TabIMFormStyled id={DEFAULT_INITIATE_PROPOSAL_FORM_ID} formController={form}>
      <SectionTitle title="Basic Information" />
      <IMInputText label="Proposal Name" name="proposalName" size="full" />
      <IMSelect label="Effective Date" name="effectiveDate" size="full" options={effectiveDatesOptions} />
      <IMZipCodeFieldStyled size="s" />
      <IMZipStateFieldStyled size="s" />
      <IMZipCountyFieldStyled size="s" />

      <FollowingSectionTitleStyled title="Available Product Lines" />
      <DomainProductLines domainProductLineItems={domainProductLineItems} isLoading={isDomainProductLinesLoading} />
    </TabIMFormStyled>
  );
});

export default DefaultInitiateProposalForm;
